import React from 'react';
import cn from 'bem-cn';

import { RankType } from '../../Leaderboard/LeaderboardItem/Rank/Rank.types';

import goldenWreath from '../../../images/icons/wreath_gold.svg';
import silverWreath from '../../../images/icons/wreath_silver.svg';
import bronzeWreath from '../../../images/icons/wreath_bronze.svg';
import paperWreath from '../../../images/icons/wreath_paper.svg';

import { ScoreBadge, ImageWithFadeIn } from '../../../components/UI';

import { AvatarWithRatingProps } from './AvatarWithRating.types';
import './AvatarWithRating.scss';

const b = cn('avatar-with-rating');

export const AvatarWithRating: React.FC<AvatarWithRatingProps> = ({
    avatarSrc,
    size,
    hideScore = false,
    score,
    isScoreLoading,
    scoreError,
    rank,
}) => {
    const type =
        {
            '1': RankType.Gold,
            '2': RankType.Silver,
            '3': RankType.Bronze,
        }[rank || 0] || RankType.Paper;

    const typeToWreath = {
        gold: goldenWreath,
        silver: silverWreath,
        bronze: bronzeWreath,
        paper: paperWreath,
    };

    return (
        <div className={b({ size })}>
            {avatarSrc && <ImageWithFadeIn src={avatarSrc} alt="Аватар" className={b('image')} />}
            {type && <ImageWithFadeIn src={typeToWreath[type]} alt="" className={b('wreath')} />}
            {!hideScore && !scoreError && (
                <ScoreBadge size={size} score={score} isLoading={isScoreLoading} showPrefix={size === 'large'} />
            )}
        </div>
    );
};
